<template>
  <div class="profile-shell">
    <ServerError v-if="ServerError" />
    <PageLoader :storage="appLoading" />
    <!--
      The validation in updatepassword() has always set msg/showSnackBar, but
      there was no snackbar on the page to show them - "Please Provide Password"
      and friends went nowhere. Render it.
    -->
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-container fluid class="pa-5">
      <!-- ============ hero ============ -->
      <div class="profile-hero">
        <span class="hero-bar"></span>
        <div class="hero-left">
          <!-- the app header identifies you by your initial; match it here -->
          <div class="hero-avatar">{{ initial }}</div>
          <div class="hero-copy">
            <div class="hero-eyebrow">
              <v-icon size="13">mdi-account-circle-outline</v-icon>
              Signed in as
            </div>
            <div class="hero-title">{{ displayName }}</div>
            <div class="hero-meta">
              <span class="meta-chip" v-if="userdetails.phone">
                <v-icon size="13">mdi-phone-outline</v-icon>
                {{ userdetails.phone }}
              </span>
              <span class="meta-chip" v-if="userdetails.email">
                <v-icon size="13">mdi-email-outline</v-icon>
                {{ userdetails.email }}
              </span>
              <span class="meta-chip" v-if="userdetails.divisionName">
                <v-icon size="13">mdi-office-building-outline</v-icon>
                {{ userdetails.divisionName }}
              </span>
            </div>
          </div>
        </div>
        <div class="hero-right">
          <span class="role-chip" v-if="userdetails.type">
            <v-icon size="13">mdi-shield-account-outline</v-icon>
            {{ userdetails.type }}
          </span>
          <div class="hero-actions" v-if="mainRole === 'MedicalOfficer'">
            <v-btn small depressed class="btn-ghost" @click="changePassword = true">
              <v-icon small left>mdi-lock-reset</v-icon>
              <span class="btnlabel">Change Password</span>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- ============ account details ============ -->
      <div class="panel">
        <div class="panel-head">
          <div class="panel-icon"><v-icon size="19">mdi-account-details-outline</v-icon></div>
          <div class="panel-copy">
            <div class="cardtitle">Account Details</div>
            <div class="subtext">Your identification and posting on this portal</div>
          </div>
        </div>

        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md4 lg3 pa-2 v-for="(field, i) in profileFields" :key="i">
            <div class="detail-cell">
              <div class="detail-icon"><v-icon size="15">{{ field.icon }}</v-icon></div>
              <div class="detail-copy">
                <div class="itemKey">{{ field.label }}</div>
                <div class="itemValue">{{ field.value }}</div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- ============ change password ============ -->
    <v-dialog v-model="changePassword" max-width="480">
      <v-card rounded="lg">
        <div class="dialog-title">
          <v-icon size="19">mdi-lock-reset</v-icon>
          <span class="cardtitle">Change Password</span>
        </div>
        <v-card-text class="pt-5">
          <div class="itemKey pb-1">New Password</div>
          <v-text-field
            outlined
            dense
            type="password"
            v-model="password"
            hide-details
            class="pb-4"
          ></v-text-field>
          <div class="itemKey pb-1">Confirm Password</div>
          <v-text-field
            outlined
            dense
            type="password"
            v-model="cpassword"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn depressed class="dlg-cancel" :ripple="false" @click="changePassword = false">
            <span class="btnlabel">Cancel</span>
          </v-btn>
          <v-btn depressed class="dlg-confirm" :ripple="false" @click="updatepassword()">
            <span class="btnlabel">Update Password</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      changePassword: false,
      password: "",
      cpassword: "",
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      userName: localStorage.getItem("userName"),
      msg: null,
      userdetails: {},
    };
  },

  beforeMount() {
    this.getData();
  },
  computed: {
    mainRole() {
      return this.$store.state.userRole;
    },
    displayName() {
      var u = this.userdetails || {};
      return u.name || u.username || this.userName || "Profile";
    },
    initial() {
      return String(this.displayName).trim().charAt(0).toUpperCase() || "?";
    },
    //only the rows this account actually has; an empty posting is not a row
    profileFields() {
      var u = this.userdetails || {};
      var rows = [
        { label: "Name", value: u.username, icon: "mdi-account-outline" },
        { label: "Phone", value: u.phone, icon: "mdi-phone-outline" },
        { label: "Email", value: u.email, icon: "mdi-email-outline" },
        { label: "Role", value: u.type, icon: "mdi-shield-account-outline" },
        { label: "Division", value: u.divisionName, icon: "mdi-office-building-outline" },
        { label: "Range", value: u.rangeName, icon: "mdi-map-marker-radius-outline" },
        { label: "Station", value: u.station, icon: "mdi-home-map-marker" },
      ];
      return rows.filter(function (r) {
        return r.value;
      });
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/details",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          username: this.userName,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response) {
            this.userdetails = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    updatepassword() {
      if (!this.password) {
        this.msg = "Please Provide Password.";
        this.showSnackBar = true;
        return;
      }
      if (!this.cpassword) {
        this.msg = "Please Confirm Password.";
        this.showSnackBar = true;
        return;
      }
      if (this.password !== this.cpassword) {
        this.msg = "Password and Confirm Password must be the same.";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dmo/changepassword",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.userdetails.id,
          password: this.password,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Password Updated Successfully.";
            this.showSnackBar = true;
            this.appLoading = false;
            this.changePassword = false;
            this.password = null;
            this.cpassword = null;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* ================= design tokens =================
   The same emerald system as the dashboards' stat cards and the sidebar's
   active nav item, so this page reads as part of the same app. */
.profile-shell {
  --accent: #10b981;
  --ink: #047857;
  --tint: #f0fdf9;
  --tint-line: #d2efe3;
  --badge: #d1fae5;
  --line: #e7eef3;
  --muted: #64748b;
  --shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -12px rgba(15, 23, 42, 0.1);

  background: #f6f8fb;
  min-height: 100vh;
  padding-bottom: 2rem;
}

/* ================= typography ================= */
.cardtitle {
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1a2e23;
  letter-spacing: -0.1px;
}
.subtext {
  font-family: poppinsregular, sans-serif;
  font-size: 12.5px;
  color: var(--muted);
  line-height: 1.45;
}
.itemKey {
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8496a5;
}
.itemValue {
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 13.5px;
  color: #1a2e23;
  line-height: 1.45;
  word-break: break-word;
}
.btnlabel {
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

/* ================= hero ================= */
.profile-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px 26px 24px 30px;
  border: 1px solid var(--tint-line);
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fdfa 55%, #ecfdf5 100%);
  box-shadow: var(--shadow);
}
.hero-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--accent) 0%, var(--ink) 100%);
}
.hero-left {
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;
}
.hero-avatar {
  flex: 0 0 auto;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* a step below the brand emerald so the white initial clears 3:1 */
  background: linear-gradient(135deg, #0ea97a 0%, var(--ink) 100%);
  box-shadow: 0 8px 20px -8px rgba(5, 150, 105, 0.55);
  color: #ffffff;
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 28px;
  line-height: 1;
  letter-spacing: 0.5px;
}
.hero-copy {
  min-width: 0;
}
.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: var(--ink);
}
.hero-eyebrow .v-icon {
  color: var(--accent) !important;
}
.hero-title {
  margin-top: 3px;
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 25px;
  line-height: 1.2;
  letter-spacing: -0.6px;
  color: #1a2e23;
  word-break: break-word;
}
.hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
.meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: 1px solid var(--tint-line);
  border-radius: 999px;
  background: #ffffff;
  font-family: poppinsregular, sans-serif;
  font-size: 11.5px;
  color: #3f5c4e;
  word-break: break-all;
}
.meta-chip .v-icon {
  color: var(--accent) !important;
}
.hero-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  min-width: 0;
}
.role-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid var(--tint-line);
  border-radius: 999px;
  background: var(--badge);
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--ink);
  white-space: nowrap;
}
.role-chip .v-icon {
  color: var(--ink) !important;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.btn-ghost.v-btn {
  border-radius: 20px !important;
  background: #ffffff !important;
  border: 1px solid var(--tint-line) !important;
  box-shadow: none !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  transition: background 0.25s ease, border-color 0.25s ease;
}
.btn-ghost.v-btn,
.btn-ghost.v-btn .btnlabel,
.btn-ghost.v-btn .v-icon {
  color: var(--ink) !important;
}
.btn-ghost.v-btn:hover {
  background: var(--tint) !important;
  border-color: var(--accent) !important;
}

/* ================= panel ================= */
.panel {
  margin-top: 20px;
  padding: 22px 24px 24px 24px;
  border: 1px solid var(--line);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: var(--shadow);
}
.panel-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding-bottom: 16px;
  margin-bottom: 6px;
  border-bottom: 1px solid var(--line);
}
.panel-icon {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--badge);
}
.panel-icon .v-icon {
  color: var(--ink) !important;
}
.panel-copy {
  flex: 1 1 auto;
  min-width: 0;
  padding-top: 2px;
}

/* ================= detail grid ================= */
.detail-cell {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  height: 100%;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fcfefd;
  transition: border-color 0.25s ease, background 0.25s ease;
}
.detail-cell:hover {
  border-color: var(--tint-line);
  background: var(--tint);
}
.detail-icon {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--tint-line);
  background: #ffffff;
}
.detail-icon .v-icon {
  color: var(--ink) !important;
}
.detail-copy {
  min-width: 0;
  padding-top: 1px;
}
.detail-copy .itemValue {
  margin-top: 3px;
}

/* ================= dialog =================
   v-dialog detaches its content to the app root, so it is NOT a descendant of
   .profile-shell and the tokens declared there never cascade into it. An
   undefined var() invalidates the whole declaration, which is how a confirm
   button ends up with no background at all. Declare what the dialog needs on
   the dialog's own elements. */
.dialog-title,
.dlg-cancel.v-btn,
.dlg-confirm.v-btn {
  --accent: #10b981;
  --ink: #047857;
  --line: #e7eef3;
}
.dialog-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 22px 14px 22px;
  border-bottom: 1px solid var(--line);
}
.dialog-title .v-icon {
  color: var(--ink) !important;
}
.dlg-cancel.v-btn {
  border-radius: 20px !important;
  border: 1px solid #f3c9c9 !important;
  background: #ffffff !important;
  box-shadow: none !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}
.dlg-cancel.v-btn,
.dlg-cancel.v-btn .btnlabel {
  color: #c62828 !important;
}
.dlg-confirm.v-btn {
  border-radius: 20px !important;
  background: linear-gradient(135deg, var(--accent) 0%, var(--ink) 100%) !important;
  box-shadow: 0 4px 12px -4px rgba(5, 150, 105, 0.45) !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}
.dlg-confirm.v-btn,
.dlg-confirm.v-btn .btnlabel {
  color: #ffffff !important;
}

/* ================= responsive ================= */
@media (max-width: 700px) {
  .profile-hero {
    padding: 20px 18px 20px 22px;
  }
  .hero-right {
    align-items: flex-start;
    width: 100%;
  }
  .hero-actions {
    justify-content: flex-start;
  }
  .hero-title {
    font-size: 21px;
  }
  .hero-avatar {
    width: 56px;
    height: 56px;
    font-size: 23px;
  }
}
</style>
